import styled from '@emotion/styled';

const Underlined = styled('em')({
  fontStyle: 'normal',
  fontWeight: 500,
  textDecoration: 'underline',
});

export default Underlined;
